import { ModifyIdentity } from '@grid/models';
import { DprPersonnelDetail } from '@shared/models/dpr';

export interface DprPersonnelDetailGridData
  extends ModifyIdentity<DprPersonnelDetail> {
  name: string;
  totalEndOfDayDisplay: number;
  totalUsedDisplay: number;
  total: number;
  dailyStockDetailsTotalStartOfDay?: number;
  dailyStockDetailsTotalEndOfDay?: number;
  dailyStockDetailsTotalUsed?: number;
  workedHoursDetailsTotal?: number;
  workedHoursDetailsTotalToDate?: number;
  workedHoursDetailsPreviousTotalToDate?: number;
}
